import React, {VFC, useEffect, useState} from "react";
import {ValueFieldProps} from "@sitecore-jss/sitecore-jss-react-forms/types";
import {DateInputViewModel} from "@sitecore-jss/sitecore-jss-forms";
import {useDispatch, useSelector} from "react-redux";
import {UpdateConditionalFieldValue} from "../../../ReduxImpl/actions";
import {IReduxState} from "../../../ReduxImpl/reducers";
import "./styles.scss";
import {check} from "prettier";

const convertDate = (dateStr) => {
  const date = new Date(dateStr);

  if (isNaN(date.getTime())) {
    return "";
  } else {
    return date.toISOString().split("T")[0];
  }
};

const DateInputField: VFC<ValueFieldProps<DateInputViewModel>> = (props) => {
  const {field, tracker} = props;
  const id = field.valueField.id;
  const label = field.model.title;
  const name = field.valueField.name;
  const FieldValidationErrors = props.fieldValidationErrorsComponent;
  const dispatch = useDispatch();
  const fieldValues = useSelector((state: IReduxState) => state.fieldValues);
  const fields = useSelector((state: IReduxState) => state.fields);
  const [date, setDate] = useState(convertDate(props.value));
  const [isValid, setIsValid] = useState(false);
  const key = (field?.model?.["conditionSettings"] as any)?.fieldKey || "";
  const max = new Date().toISOString().split("T")[0];

  const checkDateAndValidity = (dateValueFromTarget) => {
    const isValid = isNaN(new Date(dateValueFromTarget).getTime()) === false;
    const date = new Date(dateValueFromTarget);
    let dateString = dateValueFromTarget;
    if (isValid) {
      dateString = date > new Date() ? max : dateValueFromTarget;
    }

    setDate(dateString);
    setIsValid(isValid);
    const newFieldValues = {...fieldValues, [key || ""]: dateString};
    dispatch(UpdateConditionalFieldValue(newFieldValues));
    props.onChange(field.valueField.name, dateString, props.isValid, []);
  };

  const onChange = (e) => {
    checkDateAndValidity(e.target.value);
  };

  const onBlur = (e) => {
    checkDateAndValidity(e.target.value);
  };

  useEffect(() => {
    if (date) {
      checkDateAndValidity(date);
    }
  }, []);

  return (
    <div
      className={`sitecore-jss-form__control sitecore-jss-form__control--text-box ${
        false ? "sitecore-jss-form__control--has-error" : ""
      }`}
    >
      <label
        htmlFor={id}
        className={`sitecore-jss-form__label ${
          true ? "sitecore-jss-form__label--has-focus" : ""
        }`}
      >
        {label}
      </label>
      <input
        id={id}
        name={name}
        className={["sitecore-jss-form__field", isValid ? "valid" : ""].join(
          " "
        )}
        type="date"
        min="2016-01-01"
        max={max}
        // onFocus={onFocus}
        onBlur={onBlur}
        onChange={onChange}
        value={date}
      />
      <FieldValidationErrors {...props} />
    </div>
  );
};

export default DateInputField;
